export const FLASH_DELAY = 10000; // 10 seconds
